import { formatMessage } from 'i18n/CurrentLocale';
import imgSrcStedin from 'img/registration/stedin.jpg';
import imgEvides from 'img/registration/evides.png';
import imgRentokil from 'img/registration/rentokil.jpg';
import logoStedin from 'img/registration/logo-stedin.svg';
import logoEvides from 'img/registration/logo-evides.svg';
import logoRentokil from 'img/registration/logo-rentokil.svg';


type SlideMap = {
    [key: number]: {
        imgSrc: any,
        quote: string,
        logo: string,
        author: string
    };
};

export const CarouselQuotes = ({ formStep }: { formStep: number }) => {

    const slides: SlideMap = {
        1: {
            imgSrc: imgSrcStedin,
            quote: formatMessage({ id: 'REGISTRATION_SLIDE_1_QUOTE' }),
            logo: logoStedin,
            author: formatMessage({ id: 'REGISTRATION_SLIDE_1_AUTHOR' })
        },
        2: {
            imgSrc: imgEvides,
            quote: formatMessage({ id: 'REGISTRATION_SLIDE_2_QUOTE' }),
            logo: logoEvides,
            author: formatMessage({ id: 'REGISTRATION_SLIDE_2_AUTHOR' })
        },
        3: {
            imgSrc: imgRentokil,
            quote: formatMessage({ id: 'REGISTRATION_SLIDE_2_QUOTE' }),
            logo: logoRentokil,
            author: formatMessage({ id: 'REGISTRATION_SLIDE_2_AUTHOR' })
        }
    };

    const currentSlide = slides[formStep];

    return (
        <>
            <div className="image-container rel">
                <img src={currentSlide.imgSrc} className="img-fit" alt="client" />
            </div>

            <div className='quote-box rel'>
                <div className='quote-box-texts'>
                    <q>"{currentSlide.quote}"</q>
                    <div className='align-right'>
                        <img src={currentSlide.logo} alt='client logo' />
                        <span>{currentSlide.author}</span>
                    </div>
                </div>
                <div className='shape-1' />
                <div className='shape-2' />
                <div className='shape-3' />
            </div>
        </>
    )
}
